/**
 * Express signup stores both B2B+B2C as a single `b2b-b2c` value.
 * Edit-profile checkboxes use separate `b2b` / `b2c` values — expand/collapse between them.
 */

/** UI checkbox values from a stored preference array. */
export function expandBusinessModelPreference(
  prefs: string[] | string | null | undefined
): string[] {
  const list = Array.isArray(prefs)
    ? prefs
    : typeof prefs === 'string' && prefs.trim()
      ? [prefs.trim()]
      : [];

  if (list.some(v => v.toLowerCase() === 'b2b-b2c')) {
    return ['b2b', 'b2c'];
  }

  return list
    .map(v => v.toLowerCase())
    .filter((v): v is 'b2b' | 'b2c' => v === 'b2b' || v === 'b2c');
}

/** Persist checkbox selection in the same shape Express signup uses. */
export function collapseBusinessModelPreference(selected: string[]): string[] {
  const unique = Array.from(
    new Set(selected.map(v => v.toLowerCase()).filter(v => v === 'b2b' || v === 'b2c'))
  );
  if (unique.includes('b2b') && unique.includes('b2c')) {
    return ['b2b-b2c'];
  }
  return unique;
}
